<template>
    <div class="inner-box">
        <!-- 검색폼 s-->
        <el-form ref="form" :model="form" label-width="120px" size="mini">
            <el-row :gutter="24">
                <el-col :span="8">
                    <el-form-item label="센터ID">
                        <el-input v-model="form.asAgentCd" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="센터명">
                        <el-input v-model="form.asAgentNm" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="대표자명">
                        <el-input v-model="form.keyManNm" readonly></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="24">
                <el-col>
                    <el-form-item label="사업장주소">
                        <el-row :gutter="2">
                            <el-col :span="3">
                                <el-input v-model="form.zipCd" readonly></el-input>
                            </el-col>
                            <el-col :span="10">
                                <el-input v-model="form.addr1" readonly></el-input>
                            </el-col>
                            <el-col :span="10">
                                <el-input v-model="form.addr2" readonly></el-input>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="24">
                <el-col :span="8">
                    <el-form-item label="사업장명">
                        <el-input v-model="form.asAgentFullNm" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="사업자번호">
                        <el-input v-model="form.businessNo" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="사업자구분">
                        <el-input v-model="form.businessType" readonly></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="24">
                <el-col :span="8">
                    <el-form-item label="업종">
                        <el-input v-model="form.territory" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="업태">
                        <el-input v-model="form.businessStatus" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="지역">
                        <el-select class="select" v-model="form.area" placeholder="상담유형을 선택하세요." disabled>
                            <el-option value='' label="선택">선택</el-option>
                            <el-option
                            v-for="item in combos['catIdArea']"
                            :key="item.value"
                            :label="item.value"
                            :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="24">
                <el-col :span="8">
                    <el-form-item label="대표전화번호">
                        <el-input v-model="form.telNo" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="핸드폰번호">
                        <el-input v-model="form.hpNo" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="E-Mail">
                        <el-input v-model="form.email" readonly></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="24">
                <el-col :span="16">
                    <el-form-item label="담당지역">
                        <el-input v-model="form.description" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="센터구분">
                        <el-select class="select" v-model="form.asAgentType" placeholder="상담유형을 선택하세요." disabled>
                            <el-option value='' label="선택">선택</el-option>
                            <el-option
                            v-for="item in combos['asAgentType']"
                            :key="item.value"
                            :label="item.value"
                            :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="24">
                <el-col :span="8">
                    <el-form-item label="이행보증보험">
                        <el-input v-model="form.guaranteeInsurance" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="계약기간">
                        <el-row>
                            <el-col :span="12">
                                <el-input v-model="form.contractStartDt" readonly></el-input>
                            </el-col>
                            <el-col :span="12">
                                <el-input v-model="form.contractEndDt" readonly></el-input>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="계약상태">
                        <el-select class="select" v-model="form.contractStatus" placeholder="상담유형을 선택하세요." disabled>
                            <el-option value='' label="선택">선택</el-option>
                            <el-option
                            v-for="item in combos['contractStatus2']"
                            :key="item.value"
                            :label="item.value"
                            :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <!-- 검색폼 e -->
         
    </div>
</template>


<script>
/**
 * * mixins
 */
import slip from '@/mixin/slip';
import common from '@/mixin/common';

/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue';

/**
 * * Modal
 */
import ModelSelectModal from '@/components/AS/NormalConsult/Modal/ModelSelectModal.vue';
import CSChgModal from '@/components/AS/NormalConsult/Modal/CSChgModal.vue';
import CallReadModal from '@/components/AS/NormalConsult/Modal/CallReadModal.vue';


/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

/**
 * 객체내의 값 초기화
 */
 $.ObjectInitialize = function (obj) {
    let self = this;
    self.obj = obj;

    $.each(obj, function (item_name, item) {
        let datatype = $.type(item);

        if (datatype == "number")
            self.obj[item_name] = 0;   // 정수는 0 으로 초기화

        else if (datatype == "string")
            self.obj[item_name] = '';   // 문자는 '' 으로 초기화

        else if (datatype == "boolean")
            self.obj[item_name] = false;   // boolean 는 false 으로 초기화

        else if (datatype == "array")
            self.obj[item_name] = [];   // 배열은 [] 으로 초기화

        else if (datatype == "object")
            self.obj[item_name] = {};   // object는  {} 으로 초기화

    });
} 

export default {
    mixins: [slip, common],
    components: {AgGridVue, DhxCalendar},
    props: ['custParam'],
    data() {
        return {
            form: {
                asAgentCd: '', /** 센터ID */
                asAgentNm: '', /** 센터명 */
                keyManNm: '', /** 대표자명 */
                zipCd: '', /** 사업장주소 */
                addr1: '', /** 사업장주소 */
                addr2: '', /** 사업장주소 */
                asAgentFullNm: '', /** 사업장명 */
                businessNo: '', /** 사업자번호 */
                businessType: '', /** 사업자구분 */
                territory: '', /** 업종 */
                businessStatus: '', /** 업태 */
                area: '', /** 지역 */
                telNo: '', /** 대표전화번호 */
                hpNo: '', /** 핸드폰 */
                email: '', /** E-Mail */
                description: '', /** 담당지역 */
                asAgentType: '', /** 센터구분 */
                guaranteeInsurance: '', /** 이행보증보험 */
                contractStartDt: '', /** 계약기간 */
                contractEndDt: '', /** 계약기간 */
                contractStatus: '' /** 계약상태 */
            },
            combos: {
                'asAgentType' : [],
                'catIdArea' : [],
                'contractStatus2' : []
            },
            callClassOpt: [], /** 상담유형리스트 */
            callClassIdOpt: [], /** 상담유형리스트 Id */
            callCatIdOpt1: [], /** 상담분류(대) */
            callCatIdIdOpt1: [], /** 상담분류(대) Id */
            callCatIdOpt2: [], /** 상담분류(중) */
            callCatIdIdOpt2: [], /** 상담분류(중) Id */
            callCatIdOpt3: [], /** 상담분류(소) */
            callCatIdIdOpt3: [], /** 상담분류(소) Id */
            callTypeRadio: [], /** 처리결과 */
            bReadOnly: false,  /** 비활성화 여부 */
            data: []
        }
    },
    computed: {
        
    },
    created() {
        this.statusBar = {
            statusPanels: [
                { statusPanel: 'agTotalRowCountComponent', align: 'right' },
            ],
        };
    },
    mounted() {
        this.init();
        this.setNormalList();
    },
    methods: {
        onReadyMain() { 
            //메인그리드 api 정의
            this.gridApi = this.gridOptions.api;
            this.columnApi = this.gridOptions.columnApi;
            this.createColumnDefs();
        },
        setNormalList(param){
            console.log('setNormalList Tab1: ', param);
            if(param){
                this.form = param || {};
            } else if (this.custParam && this.custParam.tab1AsAgentSelItem){
                this.form = this.custParam.tab1AsAgentSelItem || {};
            }
        },
        openModel(param) {
            /** 일반상담상세내역 팝업 */

            let vm = this;
            this.$modal.open({
                width: 950,
                component: CallReadModal,
                parent: this,
                props: {
                    data: {
                        callId: param.callId,
                        callTypeRadio: vm.callTypeRadio
                    }
                },
                events: {
                    close(data) {
                        console.log('close', data);
                    },
                }
            });
        },
        openModal() {
            let vm = this;
            this.$modal.open({
                width: 800,
                component: CSChgModal,
                parent: this,
                props: {
                    data: {
                        
                    },
                },
                events: {
                    close(data) {
                        console.log('close', data);
                    },
                }
            });
        },
        getCombo(param) {
            
        },
        searchModel(){
            /** 모델선택 */
            let vm = this;
            this.$modal.open({
                width: 800,
                component: ModelSelectModal,
                parent: this,
                props: {
                    data: {
                        
                    },
                },
                events: {
                    close(param) {
                        console.log('close', param);
                        vm.form.maker = param.data.maker /** 제조사 */
                        vm.form.makerNm = param.data.makerNm /** 제조사명 */
                        vm.form.modelGroupNm = param.data.modelGroupNm /** 모델그룹명 */
                        vm.form.modelGroup = param.data.modelGroup /** 모델그룹 */
                        vm.form.standardModelNm = param.data.standardModelNm /** 표준모델 */
                        vm.form.modelNm = param.data.modelNm /** 모델명 */
                        vm.form.modelId = param.data.modelId /** 모델ID */
                    },
                }
            });

        },
        async init() {
            this.$store.commit('loading');
            
            // 센터구분
            await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 327}})
                .then(response => {
                    this.combos['asAgentType'] = response.data || [];
                })
                .finally(() => {
                    //this.form.asAgentType = 'Default'; /** 디폴트 일반선택 */
                });

            // 지역 
            await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 217}})
                .then(response => {
                    this.combos['catIdArea'] = response.data || [];
                })
                .finally(() => {
                    //this.form.catIdArea = 'Default'; /** 디폴트 일반선택 */
                });
            
            // 계약상태  
            await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 27860}})
                .then(response => {
                    this.combos['contractStatus2'] = response.data || [];
                })
                .finally(() => {
                    //this.form.contractStatus2 = 'Default'; /** 디폴트 일반선택 */
                });
            this.$parent.$refs.refSearchForm.goOpen();
            this.$store.commit('finish')

        },
        enableChk(param){
            /** 입력항목 활성화처리 */
            console.log('enableChk start :', param);
            if(param === 'IN_CALL_ID'){
                if(this.form.callType === 'Processing'){
                    // 처리결과가 미완료이면 수정가능해야 함.
                    this.bReadOnly = false;
                } else {
                    this.bReadOnly = true;
                }
                
            } else {
                this.bReadOnly = false;
            }
        }
    }
}
</script>

<style scoped>
.el-form {
    border: 1px solid #c7c7c7;
    padding: 10px;
    border-radius: 5px;
}
</style>